export default __webpack_public_path__ + "static/media/p8.3b2d2852.png";